export const isCrossBorderProvider = (
    crossBorderProvider,
    crossBorderSettings
) => {
    if (!crossBorderSettings) return false

    if (crossBorderProvider === 'dhl') {
        return ['dhl', null, '', undefined].includes(
            crossBorderSettings.landing_cost_provider
        )        
    } else if (crossBorderProvider === 'hurricane') {
        return ['hurricane'].includes(
            crossBorderSettings.landing_cost_provider
        )
    } 
}
